import {
  Button,
  Stack,
  TableCell,
  TableRow,
  Typography
} from '@mui/material';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

import { TransactionType } from '@src/lib/types/purchases';
import { usePartnerDropdownContext } from '@src/context/PartnerDropdown';

const TableRowItem = (props: TransactionType) => {
  const userID = props.user.id;

  const navigate = useNavigate();
  const { partner } = usePartnerDropdownContext();

  const onViewUserDetails = () => {
    navigate(`/dashboard/users?u=${userID}`);
  }

  if(partner === "palmsplay"){
    return (
      <TableRow hover tabIndex={-1} role="checkbox" >
        <TableCell align="left">{props.id}</TableCell>
        <TableCell onClick={onViewUserDetails} component="th" scope="row" padding="none">
          <Stack direction="row" alignItems="center">
            <Button>
              <Typography variant="subtitle2" noWrap sx={{ textDecoration: 'underline' }}>
                {userID}
              </Typography>
            </Button>
          </Stack>
        </TableCell>
        <TableCell align="left">{props.user?.palmsId}</TableCell>
        <TableCell align="left">{props.user.displayName}</TableCell>
        <TableCell align="left">{props.purchaseItemName}</TableCell>
        <TableCell align="left">{props.amount}</TableCell>
        <TableCell align="left">{props.status}</TableCell>
        <TableCell align="left">{moment.parseZone(props.transactionDate).format("MM-DD-YYYY hh:mm A")}</TableCell>
      </TableRow>
    );
  }
  

  return (
    <TableRow hover tabIndex={-1} role="checkbox" >
      <TableCell onClick={onViewUserDetails} component="th" scope="row" padding="none">
        <Stack direction="row" alignItems="center">
          <Button>
            <Typography variant="subtitle2" noWrap sx={{ textDecoration: 'underline' }}>
              {userID}
            </Typography>
          </Button>
        </Stack>
      </TableCell>
      <TableCell align="left">{props.user.displayName}</TableCell>
      <TableCell align="left">{props.purchaseItemName}</TableCell>
      <TableCell align="left">{props.amount}</TableCell>
      <TableCell align="left">{props.status}</TableCell>
      <TableCell align="left">{moment.parseZone(props.transactionDate).format("MM-DD-YYYY hh:mm A")}</TableCell>
    </TableRow>
  );
}

export default TableRowItem;
